import { FC } from 'react'
import { RenderIf } from 'components/RenderIf'
import { AllergenImages } from 'featureSliced/shared/utils/AllergenImages'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

import {
  Allergen,
  AllergenItem,
  AllergensContainer,
  AllergensSections,
  AllergensTitle,
  AllergenText,
} from './styled'

type AllergensProps = {
  product: Pick<IProduct, 'allergens' | 'allergenLabels'>
}

const ICON_ONLY_THRESHOLD = 7

export const Allergens: FC<AllergensProps> = ({ product }) => {
  const t = useTranslations()
  const { allergens: commonAllergens } = useMySelector((state) => state.common)
  const iconOnly = (product?.allergens?.length || 0) > ICON_ONLY_THRESHOLD

  return (
    <RenderIf condition={!!product?.allergens?.length}>
      <AllergensSections>
        <AllergensTitle>{t('filters.allergens')}</AllergensTitle>
        <AllergensContainer>
          {product?.allergens?.map((allergen, idx) => {
            const label =
              product.allergenLabels?.[idx] ||
              commonAllergens?.find((a) => a.id === allergen.id)?.name ||
              allergen.label

            return (
              <AllergenItem
                key={`product_allergen__${allergen.id}`}
                $iconOnly={iconOnly}
                data-tooltip={iconOnly ? label : undefined}
                tabIndex={iconOnly ? 0 : undefined}
              >
                <Allergen
                  src={AllergenImages[allergen.id] || AllergenImages[0]}
                  alt={label}
                />
                <RenderIf condition={!iconOnly}>
                  <AllergenText>{label}</AllergenText>
                </RenderIf>
              </AllergenItem>
            )
          })}
        </AllergensContainer>
      </AllergensSections>
    </RenderIf>
  )
}
